import React, { useState } from 'react';
import { api } from '../api';

export default function ComposeModal({ accounts, onClose }) {
  const [accountId, setAccountId] = useState(accounts[0]?.id || '');
  const [to, setTo] = useState('');
  const [cc, setCc] = useState('');
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showCc, setShowCc] = useState(false);

  async function send() {
    if (!to || !subject) return setError('To and Subject are required');
    setError('');
    setLoading(true);
    try {
      await api.sendMail(accountId, { to, cc, subject, text: body });
      setSent(true);
      setTimeout(onClose, 1500);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }

  const overlay = {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.6)',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    zIndex: 100,
    padding: 24,
  };
  const modal = {
    width: 600,
    background: 'var(--bg1)',
    border: '1px solid var(--line)',
    borderRadius: 10,
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
  };
  const header = {
    padding: '14px 18px',
    borderBottom: '1px solid var(--line)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  };
  const inp = {
    background: 'transparent',
    border: 'none',
    borderBottom: '1px solid var(--line)',
    borderRadius: 0,
    padding: '10px 16px',
  };
  const body2 = {
    flex: 1,
    padding: '14px 16px',
    fontSize: 14,
    background: 'transparent',
    border: 'none',
    borderRadius: 0,
    resize: 'none',
    minHeight: 220,
    color: 'var(--text0)',
  };

  if (sent)
    return (
      <div style={overlay}>
        <div style={{ ...modal, padding: 32, alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ color: 'var(--green)', fontSize: 28 }}>✓</div>
          <div style={{ marginTop: 8, color: 'var(--text1)' }}>Message sent!</div>
        </div>
      </div>
    );

  return (
    <div style={overlay}>
      <div style={modal}>
        <div style={header}>
          <span style={{ fontWeight: 600 }}>New Message</span>
          <button onClick={onClose} style={{ color: 'var(--text2)', fontSize: 20 }}>
            ×
          </button>
        </div>

        <div style={{ padding: '0 0' }}>
          <div style={{ padding: '4px 16px', borderBottom: '1px solid var(--line)' }}>
            <select
              value={accountId}
              onChange={e => setAccountId(e.target.value)}
              style={{
                background: 'transparent',
                border: 'none',
                color: 'var(--text2)',
                fontSize: 12,
                padding: '8px 0',
                width: 'auto',
              }}
            >
              {accounts.map(a => (
                <option key={a.id} value={a.id}>
                  {a.label}
                </option>
              ))}
            </select>
          </div>
          <input value={to} onChange={e => setTo(e.target.value)} placeholder="To" style={inp} />
          {showCc && (
            <input value={cc} onChange={e => setCc(e.target.value)} placeholder="Cc" style={inp} />
          )}
          <div
            style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid var(--line)' }}
          >
            <input
              value={subject}
              onChange={e => setSubject(e.target.value)}
              placeholder="Subject"
              style={{ ...inp, border: 'none', flex: 1 }}
            />
            <button
              onClick={() => setShowCc(p => !p)}
              style={{ fontSize: 11, color: 'var(--text2)', padding: '0 12px' }}
            >
              Cc
            </button>
          </div>
          <textarea
            value={body}
            onChange={e => setBody(e.target.value)}
            placeholder="Write your message…"
            style={body2}
          />
        </div>

        {error && (
          <div style={{ color: 'var(--red)', fontSize: 13, padding: '0 16px 8px' }}>{error}</div>
        )}

        <div
          style={{
            padding: '12px 16px',
            borderTop: '1px solid var(--line)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <button onClick={onClose} style={{ color: 'var(--text2)', fontSize: 13 }}>
            Discard
          </button>
          <button
            onClick={send}
            disabled={loading}
            style={{
              padding: '9px 22px',
              background: 'var(--accent)',
              color: '#fff',
              borderRadius: 'var(--radius)',
              fontWeight: 600,
            }}
          >
            {loading ? 'Sending…' : '↑ Send'}
          </button>
        </div>
      </div>
    </div>
  );
}
